import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableContainer, Chip } from "@mui/material";
import { CommonButton } from "@/components/common/buttons/CommonButton";
import type { AccidentReportPerson } from "@/models/accidentReportPersons";
import {
  learningStatusColor,
  learningStatusLabel,
} from "@/components/accidentReportPersons/learningStatusDisplay";
import { AccidentReportPersonsConstants as Constants } from "./AccidentReportPersonsConstants";

export type AccidentReportPersonsListProps = {
  // 一覧は常に1営業所に絞り込むため、1レコード＝その営業所の責任者1名として表示する。
  // 兼務（同一人物）はGO社内でのみ扱うため、事業者向けの一覧では表示しない。
  persons: AccidentReportPerson[];
  onClickDetail: (id: number) => void;
};

type PersonRowProps = {
  person: AccidentReportPerson;
  onClickDetail: (id: number) => void;
};

// 検索条件の切替など一覧と無関係な状態変化で全行分のクロージャが再生成されるのを防ぐため、
// 行を React.memo 化する。onClickDetail が安定している（親で useCallback 済み）ことが前提
const PersonRow = React.memo(({ person, onClickDetail }: PersonRowProps) => (
  <TableRow hover sx={{ wordBreak: "break-all" }}>
    <TableCell>{person.name ?? "-"}</TableCell>
    <TableCell>{person.email ?? "-"}</TableCell>
    <TableCell>{person.phoneNumber ?? "-"}</TableCell>
    <TableCell>{person.officeName ?? "-"}</TableCell>
    <TableCell>
      <Chip
        label={person.isActive ? Constants.StatusActive : Constants.StatusRetired}
        color={person.isActive ? "success" : "default"}
        size="small"
      />
    </TableCell>
    <TableCell>
      {person.learningStatus && (
        <Chip
          label={learningStatusLabel(person.learningStatus)}
          color={learningStatusColor(person.learningStatus)}
          size="small"
        />
      )}
    </TableCell>
    <TableCell sx={{ textAlign: "right", pr: 0 }}>
      <CommonButton
        btnType="Detail"
        onClickBtn={() => onClickDetail(person.id)}
      />
    </TableCell>
  </TableRow>
));

export const AccidentReportPersonsList = (
  props: AccidentReportPersonsListProps,
) => {
  const { persons, onClickDetail } = props;

  return (
    <TableContainer className="table-container-width">
      <Table size="small">
        <TableHead className="list-head">
          <TableRow>
            <TableCell>{Constants.TableNameHeader}</TableCell>
            <TableCell>{Constants.TableEmailHeader}</TableCell>
            <TableCell>{Constants.TablePhoneHeader}</TableCell>
            <TableCell>{Constants.TableOfficeHeader}</TableCell>
            <TableCell>{Constants.TableStatusHeader}</TableCell>
            <TableCell>{Constants.TableLearningStatusColumnHeader}</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {persons.map((person) => (
            <PersonRow
              key={person.id}
              person={person}
              onClickDetail={onClickDetail}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
